import AppLayout from "./AppLayout";

function App() {
  return <AppLayout />;
}

export default App;
